import { OnInit } from '@angular/core';
var LoaderComponent = /** @class */ (function () {
    function LoaderComponent() {
        this.hidden = true;
    }
    LoaderComponent.prototype.ngOnInit = function () { };
    return LoaderComponent;
}());
export { LoaderComponent };
